<template lang="html">
  <div class="code-form flex flex-col gap-3">
    <UFormField name="code" class="text-center">
      <UPinInput
        v-model="valueModel"
        autofocus
        size="xl"
        color="tertiary"
        class="m-auto"
        otp
        :disabled="props.loading"
        :length="model.confirmation?.codeLength || 6"
        @complete="emit('complete')"
      />
    </UFormField>

    <div class="code-form__resend text-center">
      <div
        v-if="timer.secondsToEnd.value && !canResend"
        key="timeToEnd"
        class="code-form__resend-timer text-muted"
      >
        Повторный код через {{ timer.timeToEnd.value }}
      </div>

      <div
        v-if="canResend && !props.loading"
        key="resend"
        class="code-form__resend-button cursor-pointer text-tertiary-500 hover:underline"
        @click="emit('resend')"
      >
        Отправить код заново
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable vue/no-mutating-props */

import type { AuthModel } from '#Auth/models'

const props = withDefaults(
  defineProps<{
    model: AuthModel
    loading?: boolean
  }>(),
  {
    loading: false,
  },
)
const emit = defineEmits<{
  resend: []
  complete: []
}>()

const timer = useTimer()
const canResend = ref(false)

watchEffect(() => {
  canResend.value = false

  if (props.model.confirmation?.retryMilliseconds) {
    timer.start(
      (props.model.confirmation?.retryMilliseconds / 1e3),
      () => {
        canResend.value = true
      },
    )
  }
})

const valueModel = computed({
  get() {
    return props.model.code?.split('') || []
  },
  set(value) {
    props.model.code = value.join('') || ''
  },
})
</script>
